const $$splitPendingComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/iframe-api/route.tsx?tsr-split=pendingComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireLoggedInUser } from '@/Router';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';

/**
 * All iframe-api routes are protected by authentication.
 */
export const Route = createFileRoute('/iframe-api')({
  pendingComponent: lazyRouteComponent($$splitPendingComponentImporter, 'pendingComponent'),
  beforeLoad() {
    requireLoggedInUser({
      to: '/auth/login'
    });
  },
  onEnter() {
    useAppStore.setState({
      isDashboard: true
    });
  }
});